module.exports = __webpack_public_path__ + "static/img/MvpBg.cc46e44c.png";